@if (this.errors) {
	<div class="">
		<app-error-presenter [errors]="this.errors"></app-error-presenter>
	</div>
} @else {
	<div
		class="list"
		[ngClass]="{ list_empty: !this.items }"
	>
		@if (!this.items || this.items.length === 0) {
			<div class="empty">
				@if (this.items && this.items.length === 0) {
					<h4 class="empty-text">Начисления не найдены</h4>
				}
			</div>
		} @else {
			<div class="list-content">
				@for (item of this.items | limitto: this.limitTo; track item; let i = $index) {
					<app-charge-item
						[charge]="item"
						[onSearchTab]="onSearchTab"
						[searchDocNumber]="searchDocNumber"
					></app-charge-item>
				}
			</div>
		}
	</div>
	@if (isVisibleToggleLimitTo()) {
		<div class="limit-to-panel">
			<a
				class="button-text"
				(click)="toggleLimitTo()"
			>
				{{ limitToLabel }}
			</a>
		</div>
	}
}
